import Privacyy from "../components/Privacy/Privacyy";


export default function PrivacyPolicy (){
  return (

  <> 
   
    
    <Privacyy/>
  
  </>

 )
}